import { getNewsRouter } from "@/utils/NewsUtil";

const MeunList = [
  {
    menuText: "HiTRUSTpay",
    functionId: "HiTRUSTpay",
    component: () => import("@/views/HiTRUSTpayView.vue"),
    meta: {
      title: "HiTRUSTpay",
      description:
        "網威智慧 HiTRUSTpay 提供一站式全方位金流支付整合方案，支援信用卡、各大行動支付、電子發票與 Shopify 跨境收單。",
      keywords: "HiTRUSTpay, 多元金流, 支付整合, 信用卡收單, 行動支付",
      priority: "0.9",
      changefreq: "weekly",
    },
    children: [
      {
        functionId: "MultiPaymentService",
        menuText: "多元支付服務",
        children: [
          {
            functionId: "CreditCard",
            menuText: "信用卡支付",
            component: () => import("@/views/CreateCardView.vue"),
            meta: {
              title: "信用卡支付",
              description:
                "提供完整信用卡刷卡交易、分期付款、紅利折抵與 3D 驗證服務，支援國內外主要發卡組織（Visa、Mastercard、JCB）。",
              keywords:
                "信用卡支付, 信用卡收款, 刷卡金流, 分期付款, 3D驗證, HiTRUSTpay",
              priority: "0.9",
              changefreq: "weekly",
            },
          },
          {
            functionId: "ApplePay",
            menuText: "Apple Pay",
            component: () => import("@/views/ApplePayView.vue"),
            meta: {
              title: "Apple Pay",
              description:
                "支援 iOS 與 Safari 快速結帳，透過 Face ID / Touch ID 雙重驗證提高結帳轉換率與交易安全。",
              keywords: "Apple Pay, 蘋果支付, 行動支付, 快速結帳, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "GooglePay",
            menuText: "Google Pay",
            component: () => import("@/views/GooglePayView.vue"),
            meta: {
              title: "Google Pay",
              description:
                "整合 Google Pay 數位錢包，支援各類 Android 裝置與 Chrome 瀏覽器快速完成付款，結帳簡單又安全。",
              keywords: "Google Pay, 谷歌支付, 行動支付, 線上結帳, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "SAMSUNGPay",
            menuText: "SAMSUNG Pay",
            component: () => import("@/views/SamsungPayView.vue"),
            meta: {
              title: "SAMSUNG Pay",
              description:
                "支援 Samsung 智慧型手機與行動穿戴裝置快速指紋或虹膜感應付款，體驗順暢結帳流程。",
              keywords: "Samsung Pay, 三星支付, 行動支付, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "iPASSMoney",
            menuText: "iPASS MONEY",
            component: () => import("@/views/IPassMoneyView.vue"),
            meta: {
              title: "iPASS MONEY",
              description:
                "整合 iPASS MONEY 電子錢包，支援掃碼支付與線上轉帳付款，擴大年輕與無卡族群消費客群。",
              keywords: "iPASS MONEY, 一卡通, 電子支付, 無卡支付, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "LINEPay",
            menuText: "LINE Pay",
            component: () => import("@/views/LinePayView.vue"),
            meta: {
              title: "LINE Pay",
              description:
                "串接台灣滲透率最高的 LINE Pay 行動支付，支援 LINE Points 點數折抵，大幅提升消費者下單意願。",
              keywords: "LINE Pay, LINE支付, LINE Points, 行動錢包, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "JKOPay",
            menuText: "街口支付",
            component: () => import("@/views/JkoPayView.vue"),
            meta: {
              title: "街口支付",
              description:
                "支援街口支付掃碼與線上付款，涵蓋廣大在地消費會員，提供即時扣款與街口幣折抵。",
              keywords: "街口支付, 街口幣, 電子支付, 行動支付, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "PXPay",
            menuText: "全支付",
            component: () => import("@/views/PxPayView.vue"),
            meta: {
              title: "全支付",
              description:
                "串接全支付，涵蓋全聯廣大線下會員消費力，打造線上線下無縫支付生態。",
              keywords: "全支付, PXPay, 全聯支付, 行動支付, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "EasycardWallet",
            menuText: "悠遊付",
            component: () => import("@/views/EasyWalletView.vue"),
            meta: {
              title: "悠遊付",
              description:
                "串接悠遊卡公司悠遊付電子錢包，支援綁定銀行帳戶與信用卡直接扣款，普及率高便利性佳。",
              keywords: "悠遊付, 悠遊卡, 電子支付, 無現金支付, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "CFC",
            menuText: "銀角零卡",
            component: () => import("@/views/ZingalaView.vue"),
            meta: {
              title: "銀角零卡",
              description:
                "支援仲信資融銀角零卡大額分期與無卡分期付款，降低消費門檻，提升高單價商品提袋率。",
              keywords:
                "銀角零卡, zingala, 先買後付, BNPL, 無卡分期, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "AFTEE",
            menuText: "AFTEE",
            component: () => import("@/views/AFTEEView.vue"),
            meta: {
              title: "AFTEE",
              description:
                "日本後支付領導品牌 AFTEE，不需繁瑣註冊即可先收到商品再付款，提升結帳轉換率。",
              keywords: "AFTEE, 先享後付, 後支付, 無卡結帳, BNPL, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
        ],
      },
      {
        functionId: "ValueAddedService",
        menuText: "商務加值服務",
        children: [
          {
            functionId: "QRPay",
            menuText: "方便付 QRPpay",
            component: () => import("@/views/QRPayView.vue"),
            meta: {
              title: "方便付 QRPpay",
              description:
                "提供商家客製化專屬 QR Code，支援消費者掃碼即可輸入金額快速付款，適合多元實體與線上場景。",
              keywords:
                "方便付, QR Code收款, 掃碼支付, 靜態碼, 動態碼, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "EmailPay",
            menuText: "方便付 Email Pay",
            component: () => import("@/views/EmailPayView.vue"),
            meta: {
              title: "方便付 Email Pay",
              description:
                "透過 Email 發送專屬客製付款帳單與金流連結，客戶點擊即可安全在線上刷卡完成繳費。",
              keywords:
                "Email Pay, 電子郵件收款, 帳單付款, 線上繳費, 方便付, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "VirtualAccountPayment",
            menuText: "虛擬帳號收款",
            component: () => import("@/views/VirtualAccountView.vue"),
            meta: {
              title: "虛擬帳號收款",
              description:
                "提供每筆訂單專屬虛擬 ATM 帳號，支援跨行轉帳、即時入帳通知與自動化系統銷帳。",
              keywords:
                "虛擬帳號, ATM轉帳, 自動銷帳, 虛擬帳號收款, 銀行轉帳, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "GroupBuy",
            menuText: "團購表單",
            component: () => import("@/views/GroupBuyView.vue"),
            meta: {
              title: "團購表單",
              description:
                "為團購主與商家量身打造的團購訂購單金流方案，整合多元收款與訂單匯出對帳功能。",
              keywords: "團購表單, 團購金流, 團購收款, 團媽對帳, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "FastPay",
            menuText: "速速付",
            component: () => import("@/views/FastPayView.vue"),
            meta: {
              title: "速速付",
              description:
                "記憶常用付款方式與收件資訊，提供消費者極速一鍵結帳體驗，顯著降低購物車放棄率。",
              keywords: "速速付, FastPay, 一鍵結帳, 快速付款, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "SIP",
            menuText: "定期定額",
            component: () => import("@/views/SipView.vue"),
            meta: {
              title: "定期定額",
              description:
                "支援週期性自動信用卡扣款與訂閱制扣款，適用於定期捐款、軟體 SaaS 訂閱與定期購服務。",
              keywords:
                "定期定額, 訂閱制金流, 自動扣款, 循環扣款, 信用卡定期, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "Embed",
            menuText: "嵌入式付款頁",
            component: () => import("@/views/EmbedView.vue"),
            meta: {
              title: "嵌入式付款頁",
              description:
                "將金流結帳介面無縫嵌入商家網站中，不需跳轉外部頁面，維持品牌一致性並提高成交率。",
              keywords:
                "嵌入式付款, Follow Pay, 內嵌結帳, iFrame結帳, 品牌金流, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
          {
            functionId: "Einvoice",
            menuText: "電子發票",
            component: () => import("@/views/EinvoiceView.vue"),
            meta: {
              title: "電子發票",
              description:
                "支援 B2B 與 B2C 電子發票自動開立、作廢、折讓與載具歸戶，符合財政部最新法規標準。",
              keywords:
                "電子發票, 財政部發票, 雲端發票, 發票折讓, 自動對獎, HiTRUSTpay",
              priority: "0.8",
              changefreq: "monthly",
            },
          },
        ],
      },
      {
        functionId: "Shopify",
        menuText: "Shopify 開店平台",
        component: () => import("@/views/ShopifyView.vue"),
        meta: {
          title: "Shopify 開店平台",
          description:
            "Shopify 官方認證合作夥伴，串接 Global Payments 支援在地與美金跨境信用卡收單，助品牌拓展海外市場。",
          keywords:
            "Shopify金流, Shopify台灣, Shopify跨境, Global Payments, 美金收單, HiTRUSTpay",
          priority: "0.9",
          changefreq: "weekly",
        },
      },
    ],
  },
  {
    menuText: "智慧資安",
    functionId: "SmartCybersecurity",
    component: () => import("@/views/CybersecurityView.vue"),
    meta: {
      isCyber: true,
      title: "智慧資安",
      description:
        "HiTRUST 智慧資安提供無密碼身分驗證、AI 設備識別防詐、EMV 3DS 交易驗證與數位憑證，打造金融級資安防護體系。",
      keywords:
        "智慧資安, VeriFido, Veri-id, 3-D Secure, 設備指紋, AI防詐, HiTRUST",
      priority: "0.9",
      changefreq: "weekly",
    },
    colNum: 2,
    children: [
      {
        functionId: "ProductService",
        menuText: "產品服務",
        children: [
          {
            functionId: "VeriFido",
            menuText: "Veri FIDO 無密碼身份驗證",
            meta: {
              isCyber: true,
              title: "Veri FIDO 無密碼身份驗證",
              description:
                "符合 FIDO 國際聯盟標準，支援生物辨識與 Passkey 快速免密碼登入，徹底杜絕釣魚網站與帳密外洩風險。",
              keywords:
                "VeriFido, FIDO2, Passkey, 無密碼登入, 生物辨識, 身份驗證, HiTRUST",
              priority: "0.9",
              changefreq: "weekly",
            },
            component: () => import("@/views/VeriFidoView.vue"),
          },
          {
            functionId: "VeriId",
            menuText: "Veri-id 設備識別與 AI 即時風險分析",
            meta: {
              isCyber: true,
              title: "Veri-id 設備識別與 AI 即時風險分析",
              description:
                "利用獨家專利設備指紋技術結合 AI 機器學習即時評估交易風險，精準防範盜刷、幽靈設備與惡意詐欺行為。",
              keywords:
                "Veri-id, 設備指紋, AI風控, 交易防詐, 盜刷防範, 機器人偵測, HiTRUST",
              priority: "0.9",
              changefreq: "weekly",
            },
            component: () => import("@/views/VeriIdView.vue"),
          },
          {
            functionId: "ThreeDS",
            menuText: "3DS 信用卡交易驗證服務",
            meta: {
              isCyber: true,
              title: "3DS 信用卡交易驗證服務",
              description:
                "通過 EMVCo 與 Visa/Mastercard/JCB 國際認證，支援 3DS 2.0+ 智慧無感認證，兼顧交易安全與結帳轉換率。",
              keywords:
                "3D驗證, 3-D Secure, EMV 3DS, 信用卡驗證, OTP驗證, 盜刷責任移轉, HiTRUST",
              priority: "0.9",
              changefreq: "weekly",
            },
            component: () => import("@/views/ThreeDSView.vue"),
          },
          {
            functionId: "SSL",
            menuText: "數位安全憑證",
            meta: {
              isCyber: true,
              title: "數位安全憑證",
              description:
                "代理全球頂級 CA 數位憑證（DigiCert、Sectigo 等），提供專業安裝諮詢與全天候安全守護。",
              keywords:
                "SSL憑證, TLS加密, 數位憑證, HTTPS, 網站安全, DigiCert, HiTRUST",
              priority: "0.8",
              changefreq: "monthly",
            },
            component: () => import("@/views/SSLView.vue"),
          },
          {
            functionId: "Signing",
            menuText: "程式碼簽章",
            meta: {
              isCyber: true,
              title: "程式碼簽章",
              description:
                "提供 EV / OV 程式碼數位簽章服務，保護軟體與驅動程式免遭竄改，消除 Windows SmartScreen 警告提升下載信任度。",
              keywords:
                "程式碼簽章, Code Signing, EV簽章, 軟體簽章, 驅動程式簽章, HiTRUST",
              priority: "0.8",
              changefreq: "monthly",
            },
            component: () => import("@/views/SigningView.vue"),
          },
        ],
      },
      {
        functionId: "Solution",
        menuText: "解決方案",
        children: [
          {
            functionId: "LoginSecurity",
            menuText: "帳號登入安全",
            meta: {
              isCyber: true,
              title: "帳號登入安全",
              description:
                "打造全方位零信任帳號防護架構，整合多因子驗證 (MFA) 與行為風險偵測，守護企業數位資產。",
              keywords:
                "帳號登入安全, MFA, 多因子驗證, 零信任, 身份安全, HiTRUST",
              priority: "0.8",
              changefreq: "monthly",
            },
            component: () => import("@/views/LoginSecurityView.vue"),
          },
          {
            functionId: "ATO",
            menuText: "帳號接管(ATO)防護",
            meta: {
              isCyber: true,
              title: "帳號接管(ATO)防護",
              description:
                "針對憑證填充（Credential Stuffing）與暴力破解等帳號接管攻擊提供即時攔截，保護會員帳號不被盜用。",
              keywords:
                "帳號接管, ATO防護, 撞庫攻擊, 憑證填充, 帳號安全, HiTRUST",
              priority: "0.8",
              changefreq: "monthly",
            },
            component: () => import("@/views/ATOView.vue"),
          },
          {
            functionId: "RTSA",
            menuText: "線上交易防詐",
            meta: {
              isCyber: true,
              title: "線上交易防詐",
              description:
                "即時多維度分析交易情境與設備行為特徵，於交易進行當下即時預警可疑盜刷，守護商戶營收與信譽。",
              keywords:
                "線上交易防詐, 即時防詐, RTSA, 詐欺偵測, 交易安全, HiTRUST",
              priority: "0.8",
              changefreq: "monthly",
            },
            component: () => import("@/views/RTSAView.vue"),
          },
          {
            functionId: "AbuseTesting",
            menuText: "行銷濫用偵測",
            meta: {
              isCyber: true,
              title: "行銷濫用偵測",
              description:
                "精準識別惡意機器人與多開帳號，有效防止行銷優惠券被濫用盜領、搶購囤貨與惡意刷單。",
              keywords:
                "行銷濫用偵測, 薅羊毛防範, 機器人防護, 優惠券防盜, 惡意搶購, HiTRUST",
              priority: "0.8",
              changefreq: "monthly",
            },
            component: () => import("@/views/AbuseTestingView.vue"),
          },
          {
            functionId: "Protection",
            menuText: "程式與系統保護",
            meta: {
              isCyber: true,
              title: "程式與系統保護",
              description:
                "提供全方位軟體程式保護、反逆向工程與核心系統防護，確保企業商業邏輯與原始碼安全。",
              keywords:
                "程式保護, 系統防護, 反逆向工程, 原始碼保護, 企業資安, HiTRUST",
              priority: "0.8",
              changefreq: "monthly",
            },
            component: () => import("@/views/ProtectionView.vue"),
          },
        ],
      },
    ],
  },
  {
    menuText: "資源中心",
    functionId: "ResourceCenter",
    menuCenter: true,
    children: [
      {
        functionId: "ApiDoc",
        menuText: "串接文件",
        component: () => import("@/views/ApiDocView.vue"),
        meta: {
          title: "串接文件",
          description:
            "提供完整 HiTRUSTpay 金流與智慧資安 API 串接規格文件、SDK 下載與測試環境指南，協助工程團隊快速上線。",
          keywords: "API文件, 金流串接, 技術手冊, SDK下載, 開發者中心, HiTRUST",
          priority: "0.7",
          changefreq: "monthly",
        },
      },
      {
        functionId: "QA",
        menuText: "常見問題",
        component: () => import("@/views/QAView.vue"),
        meta: {
          title: "常見問題",
          description:
            "整理商家與消費者最常見的金流支付、發票開立、後台操作與資安產品疑問，提供詳盡解答與指引。",
          keywords: "常見問題, Q&A, 客服解答, 金流操作, 發票問題, HiTRUST",
          priority: "0.7",
          changefreq: "weekly",
        },
      },
    ],
  },
  {
    menuText: "最新消息",
    functionId: "News",
    component: () => import("@/views/NewsView.vue"),
    meta: {
      title: "最新消息",
      description:
        "即時掌握 HiTRUST 網威智慧最新產品動態、產業資安趨勢分析、活動展會資訊與專訪報導。",
      keywords: "最新消息, 焦點新聞, 資安新聞, 金流趨勢, 產業洞察, HiTRUST",
      priority: "0.8",
      changefreq: "daily",
    },
  },
  {
    menuText: "公司介紹",
    functionId: "CompanyIntroduction",
    menuCenter: true,
    children: [
      {
        functionId: "AboutUs",
        menuText: "關於我們",
        component: () => import("@/views/AboutUsView.vue"),
        meta: {
          title: "關於我們",
          description:
            "網威智慧深耕金融科技與電子商務金流 25 年，服務台灣過半金融機構與上萬家電商，致力以 AI 與資安創新引領未來。",
          keywords:
            "關於網威, HiTRUST介紹, 網際威信, 金融科技, 資安公司, 企業沿革",
          priority: "0.7",
          changefreq: "monthly",
        },
      },
      {
        functionId: "PrivacyPolicy",
        menuText: "隱私權政策",
        component: () => import("@/views/PrivacyPolicyView.vue"),
        meta: {
          title: "隱私權政策",
          description:
            "網威智慧極度重視您的隱私權益，本政策詳細說明我們如何收集、處理、利用與保護您的個人資料。",
          keywords: "隱私權政策, 個人資料保護, 個資宣告, HiTRUST",
          priority: "0.6",
          changefreq: "yearly",
        },
      },
      {
        functionId: "Certificate",
        menuText: "專業認證 ＆ 證書",
        component: () => import("@/views/CertificateView.vue"),
        meta: {
          title: "專業認證 ＆ 證書",
          description:
            "榮獲 ISO 27001 資安管理、PCI-DSS 支付卡產業資料安全標準與各大國際發卡組織官方合規認證。",
          keywords: "專業認證, ISO27001, PCI-DSS, EMVCo認證, 資安認證, HiTRUST",
          priority: "0.7",
          changefreq: "monthly",
        },
      },
      {
        functionId: "Award",
        menuText: "榮譽與獎項",
        component: () => import("@/views/AwardView.vue"),
        meta: {
          title: "榮譽與獎項",
          description:
            "歷年榮獲數發部數位創新獎、各大金融創新展會大獎與業界領先肯定，展現卓越技術實力。",
          keywords: "榮譽獎項, 得獎紀錄, 數位創新獎, 金融科技獎, HiTRUST",
          priority: "0.7",
          changefreq: "monthly",
        },
      },
    ],
  },
];

const OtherRouter = [];

export function getMenu() {
  return MeunList;
}

let functionIds = {};
export function getFunIdAndText() {
  if (Object.keys(functionIds).length > 0) return functionIds;
  const result = {};
  flattenMenu(MeunList, result);
  functionIds = result;
  return result;
}

function flattenMenu(items, result) {
  items.forEach((item) => {
    result[item.functionId] = item.menuText;
    // 遞迴處理子選單
    if (item.children) {
      flattenMenu(item.children, result);
    }
  });
}

const menuRouter = [];

export function getMenuRouter() {
  if (menuRouter.length > 0) return menuRouter;
  MeunList.forEach((element) => {
    parseMenuRouter(menuRouter, element);
  });

  OtherRouter.forEach((element) => {
    parseMenuRouter(menuRouter, element);
  });

  parseMenuRouter(menuRouter, getNewsRouter());

  return menuRouter;
}

function parseMenuRouter(router, obj, setPath = true) {
  let route = {};
  if (obj.component && obj.functionId) {
    const id = obj.functionId;
    const meta = obj?.meta ? { ...obj.meta } : {};
    if (obj.menuText && !meta.title) {
      meta.title = obj.menuText;
    }
    let path = id;
    if (setPath) {
      path = "/" + path;
    }

    route = {
      path: path,
      component: obj.component,
      name: id,
      meta,
    };
    router.push(route);

    if (obj.children) {
      if (meta.setChild) {
        const child = [];
        obj.children.forEach((element) => {
          parseMenuRouter(child, element, false);
        });
        route["children"] = child;
      } else {
        obj.children.forEach((element) => {
          parseMenuRouter(router, element);
        });
      }
    }
  } else if (obj.children) {
    obj.children.forEach((element) => {
      parseMenuRouter(router, element);
    });
  }
}
